<template>
  <v-chip
    v-if="entriesValues.length > 1"
    :color="iconColor"
    label
    :outlined="isEvolutionStable"
    variant="flat"
    class="d-flex justify-space-between"
    :class="isEvolutionStable ? 'chip-stable' : 'chip'"
  >
    <div class="white--text d-flex align-self-center">
      <div
        v-if="!isEvolutionStable && evolutionValue >= 0"
        class="texte white--text align-self-center"
      >
        +
      </div>
      <div
        v-if="!isEvolutionStable"
        class="texte white--text align-self-center"
      >
        {{ evolutionValue | roundNumber(0) }} % *
      </div>
      <div
        v-if="isEvolutionStable"
        class="texte texte-gris-fonce align-self-center"
      >
        Stable
      </div>
      <v-icon
        size="23"
        class="align-self-center mr-1"
      >
        {{ iconName }}
      </v-icon>
    </div>
    <div class="align-self-center position-icon-info">
      <v-menu
        ref="menu"
        top
        content-class="elevation-0"
        :nudge-left="estVueMobile ? '' : '98'"
        offset-y
        transition="fade-transition"
        @input="onBasculeBulle"
      >
        <template v-slot:activator="{ on, attrs, value }">
          <img
            v-if="isEvolutionStable"
            ref="picto"
            v-bind="attrs"
            class="align-self-center pt-1"
            src="@/assets/icon-info-gris.svg"
            v-on="on"
          >
          <img
            v-else
            ref="picto"
            v-bind="attrs"
            class="align-self-center pt-1"
            src="@/assets/icon-info-blanc.svg"
            v-on="on"
          >
        </template>
        <div
          v-if="entriesValues!= null"
          ref="bulle"
          class="menu-item-resume"
          :class="estVueMobile ? '' : 'menu-item-resume__top'"
          :style="styleFleche"
        >
          <div
            v-for="(item, index) in entriesValues"
            :key="index"
          >
            <div class="d-flex justify-space-between my-2">
              <div class="align-self-center intro texte-gris-fonce mr-12">
                {{ item[0] }}
              </div>
              <div class="align-self-center titre-h3 secondary--text">
                {{ item[1] | roundNumber(precision) | splitNumber }} {{ unite }}
              </div>
            </div>
            <v-divider v-if="index < entriesValues.length - 1" />
          </div>
        </div>
      </v-menu>
    </div>
  </v-chip>
</template>

<script>
import { mesurerApresPlacement, positionFlecheSousActivateur, DUREE_AFFICHAGE_BULLE } from '@/utils/bulle'

export default {
  name: 'BaseEvolutionWithInfo',
  props: {
    evolutionValue: {
      type: Number,
      default: null
    },
    values: {
      type: Object,
      default: null
    },
    unite: {
      type: String,
      default: 'ha'
    },
    precision: {
      type: Number,
      default: 0
    },
    hausseFavorable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      location: 'bottom',
      offset: true,
      positionFleche: null,
      minuterieFermeture: null
    }
  },
  computed: {
    estVueMobile () {
      return this.$vuetify.breakpoint.smAndDown
    },
    styleFleche () {
      return this.positionFleche != null ? { '--position-fleche': this.positionFleche + 'px' } : {}
    },
    iconName () {
      let result
      if (this.evolutionValue > 5) {
        result = 'mdi-arrow-top-right'
      } 
      else if  (this.evolutionValue < -5) {
        result = 'mdi-arrow-bottom-right'
      } 
      else {
        result = ''
      }
      return result
    },
    isEvolutionStable () {
      return this.evolutionValue > -5 && this.evolutionValue < 5
    },

    iconColor () {
      const vert = 'secondary'
      const orange = '#EC6608'
      let result
      if (this.evolutionValue > 5) {
        result = this.hausseFavorable ? vert : orange
      } 
      else if  (this.evolutionValue < -5) {
        result = this.hausseFavorable ? orange : vert
      } 
      else {
        result = 'grey'
      }
      return result
    },
    entriesValues () {
      return this.values != null ? Object.entries(this.values) : []
    }
  },

  beforeDestroy () {
    clearTimeout(this.minuterieFermeture)
  },

  methods: {
    onBasculeBulle (estOuverte) {
      this.positionnerFleche(estOuverte)
      this.programmerFermeture(estOuverte)
    },

    fermerBulle () {
      if (this.$refs.menu != null) {
        this.$refs.menu.isActive = false
      }
    },
    programmerFermeture (estOuverte) {
      clearTimeout(this.minuterieFermeture)

      if (estOuverte && this.estVueMobile) {
        this.minuterieFermeture = setTimeout(() => this.fermerBulle(), DUREE_AFFICHAGE_BULLE)
      }
    },

    positionnerFleche (estOuverte) {
      if (!estOuverte) {
        this.positionFleche = null
        return
      }

      mesurerApresPlacement(this, () => {
        this.positionFleche = positionFlecheSousActivateur(this.$refs.picto, this.$refs.bulle)
        return this.positionFleche
      })
    }
  }

}
</script>
<style lang="scss" scoped>
.menu-item-resume {
  position: relative;
  padding: 16px;
  margin: 14px;
  border-radius: 12px;
  background-color: #ffffff;
  filter: drop-shadow(
      0px 3px 1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2))
    )
    drop-shadow(
      0px 2px 2px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14))
    )
    drop-shadow(
      0px 1px 5px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12))
    );
  &.menu-item-resume__top::after {
    content: '';
    position: absolute;
    z-index: -10;
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    background-color: #ffffff;
    bottom: -5px;
    left: var(--position-fleche, calc(50% - 10px));
  }
}
@media (max-width: 960px) {
  .menu-item-resume {
    max-width: calc(100vw - 48px);
  }
}

.chip {
  width: 120px;
}
.chip-stable {
  width: 90px;
}
.position-icon-info {
  position: absolute;
  right: 8px;
}
</style>